<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" :label="$t('Inicio')" :key="render">
        <div class="content-username">
          <span class="username">
            <b>{{ username }}</b>
          </span>
          <br />
          <span style="font-size: 12px;">Usted ha ingresado a la plataforma con el siguiente rol</span>
        </div>
        <br />
        <div style="margin-left: 21px; max-width: 990px; font-size: 15px;">
          <div style="margin-bottom: 6px;">
            <b>
              <span>La faena en la que he ingresado es:</span>
            </b>
            <span style="margin-left: 10px;">{{faenas[$store.getters.role.faena_id]}}</span>
            <br />
          </div>
          <div
            style="margin-bottom: 6px;"
            v-if="$store.getters.role.area_id && !$store.getters.role.admin"
          >
            <b>
              <span>El área en la que he ingresado es:</span>
            </b>
            <span style="margin-left: 10px;">{{ areaName($store.getters.role.area_id) }}</span>
            <br />
          </div>
          <div
            style="margin-bottom: 6px;"
            v-if="$store.getters.role.empresa_id && !$store.getters.role.admin"
          >
            <b>
              <span>La empresa en la que he ingresado es:</span>
            </b>
            <span style="margin-left: 10px;">{{ companyName($store.getters.role.empresa_id)}}</span>
            <br />
          </div>
          <div style="margin-bottom: 6px;">
            <b>
              <span>Mi rol para evaluar los inventarios es:</span>
            </b>
            <span
              style="margin-left: 10px;"
              v-if="!$store.getters.role.admin"
            >{{ bhpProfiles[$store.getters.role.role] || $store.getters.role.role }}</span>
            <span
              style="margin-left: 10px;"
              v-if="$store.getters.role.admin === true"
            >Administrador del sistema</span>
          </div>
        </div>
        <br />
        <el-row>
          <el-col :md="14">
            <table
              border="0"
              cellspacing="10"
              style="font-size: 15px;"
              v-loading="loading"
              element-loading-text="Cargando información..."
              element-loading-background="rgba(255, 255, 255)"
            >
              <tr>
                <td></td>
                <td
                  class="border color-bhp-text text-center"
                >{{faenas[$store.getters.role.faena_id]}}</td>
                <td class="border color-bhp-text text-center">Empresas Colaboradoras</td>
              </tr>
              <tr>
                <td class="fondo-amarillo-a border">N° de Inventarios en Revisión</td>
                <td
                  class="border status-text"
                >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_inv_revision.propios.count}}</td>
                <td
                  class="border status-text"
                >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_inv_revision.contratistas.count}}</td>
              </tr>
              <tr>
                <td class="fondo-amarillo-a border">N° de Tareas en Revisión</td>
                <td class="border" style="padding: 0px;">
                  <el-button
                    @click="setPendingTasks(status_inv.count_inv_revision.propios.task.tasks, 'count_inv_revision.propios.task.tasks')"
                    style="width: 100%; border-radius: 0px;"
                    type="primary"
                  >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_inv_revision.propios.task.count}}</el-button>
                </td>
                <td class="border" style="padding: 0px;">
                  <el-button
                    @click="setPendingTasks(status_inv.count_inv_revision.contratistas.task.tasks, 'count_inv_revision.contratistas.task.tasks')"
                    style="width: 100%; border-radius: 0px;"
                    type="primary"
                  >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_inv_revision.contratistas.task.count}}</el-button>
                </td>
              </tr>
              <tr>
                <td class="fondo-amarillo-b border">N° de Inventarios en Borrador</td>
                <td
                  class="border status-text"
                >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_inv_borrador.propios.count}}</td>
                <td
                  class="border status-text"
                >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_inv_borrador.contratistas.count}}</td>
              </tr>
              <tr>
                <td
                  style="background-color: #A6A08F; color: white;"
                  class="border"
                >N° de Inventarios No Iniciados</td>
                <td
                  class="border status-text"
                >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_no_iniciado.propios.count}}</td>
                <td
                  class="border status-text"
                >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_no_iniciado.contratistas.count}}</td>
              </tr>
              <tr>
                <td class="fondo-verde-a border">N° de Inventarios Aprobados</td>
                <td
                  class="border status-text"
                >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_inv_aprobados.propios.count}}</td>
                <td
                  class="border status-text"
                >{{JSON.stringify(status_inv) === "{}" ? "" : status_inv.count_inv_aprobados.contratistas.count}}</td>
              </tr>
            </table>
          </el-col>
        </el-row>
        <br />
        <div style="margin-left: 10px; margin-top: 10px;">
          <span style="color: #07758D; font-size: 13px;">
            <b>Responsabilidades de los Roles creados en la Plataforma:</b>
          </span>
          <br />
          <br />
          <table border="1" style="font-size: 13px;" cellspacing="0">
            <tr>
              <td>
                <b>Rol</b>
              </td>
              <td>
                <b>Permisos</b>
              </td>
            </tr>
            <tr>
              <td
                rowspan="4"
              >(1) Coordinador Empresa Colaboradora y Coordinador {{faenas[$store.getters.role.faena_id]}}</td>
              <td>
                → Puede ingresar, editar, eliminar información del inventario de riesgo asignado a usted, sólo cuando el inventario se encuentra en estado
                <b>BORRADOR</b>.
              </td>
            </tr>
            <tr>
              <td>→ Puede enviar a revisión el Inventario asignado.</td>
            </tr>
            <tr>
              <td>→ Puede corregir uno o mas riesgos, que fueron rechazados.</td>
            </tr>
            <tr>
              <td>→ Puede cambiar el estado de un Inventario de APROBADO a BORRADOR para actualizarlo.</td>
            </tr>
            <tr>
              <td>(2) Administrador Empresa Colaboradora</td>
              <td
                rowspan="7"
              >→ Puede aprobar o rechazar los riesgos niveles del 1 al 5, sólo cuando el inventario se encuentra en estado en revisión.</td>
            </tr>
            <tr>
              <td>(3) Asesor HSE Empresa Colaboradora:</td>
            </tr>
            <tr>
              <td>(4) Especialista de Salud, de Seguridad y de Medio Ambiente de la Compañía</td>
            </tr>
            <tr>
              <td>(5) Especialista de Riesgos de la Compañía</td>
            </tr>
            <tr>
              <td>(6) Superintendente de Área de la Compañía</td>
            </tr>
            <tr>
              <td>(7) Gerente de Area de la Compañía</td>
            </tr>
            <tr>
              <td>(8) Contract Owner de Compañía</td>
            </tr>
          </table>
          <br />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      step: 0,
      title: "",
      text_step: "",
      render: 0,
      bhpProfiles: {
        hse: "HSE",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        owner: "Dueño de Contrato",
        contract_owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        administrator: "Administrador de Contrato",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        manager: "Gerente de Área",
        super: "Superintendente de Área",
        general_manager: "Gerente General",
        superadmin: "Administrador del sistema"
      },
      status_inv: {},
      loading: false,
      faenas: {
        "5a6f78337b772dcfe68241d5": "ANTUCOYA"
      }
    };
  },
  async mounted() {
    this.$store.dispatch("setTitle", this.$t("Dashboard Personal"));
    this.$store.dispatch(
      "setSubTitle",
      this.$t("Inventario de riesgos HSE online")
    );
    if (this.$store.getters.empresas.length === 0) {
      this.$store.dispatch("getEmpresasFaena");
    }
    if (this.$store.getters.all_task_pending === null) {
      this.getStatus();
    } else {
      this.status_inv = this.$store.getters.all_task_pending;
    }
  },
  computed: {
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    empresas() {
      return this.$store.getters.empresas;
    }
  },
  methods: {
    setPendingTasks(tasks, structure) {
      this.$store.dispatch("setTareasPendientes", {
        tasks: tasks,
        structure: structure
      });
      this.$router.push({ name: "tareasPendientes" });
    },
    areaName(id) {
      if (this.$store.getters.areasRoles) {
        const area = this.$store.getters.areasRoles.find(a => a._id === id);
        return area ? area.nombre : id;
      } else {
        ("");
      }
    },
    companyName(id) {
      if (this.empresas) {
        var empresa = this.empresas.find(x => x._id === id);
        if (empresa && empresa.nombre) {
          return empresa.nombre;
        }
      } else {
        return "";
      }
    },
    getStatus() {
      this.loading = true;
      var self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      };
      let role =
        this.$store.getters.role.admin === true
          ? "superadmin"
          : this.$store.getters.role.role;
      axios
        .get(
          `/inventarios/getStatusDashboardAmsa/${this.$store.getters.role.faena_id}/${role}/${this.$store.getters.user._id}/${this.$store.getters.role.area_id}/${this.$store.getters.role.empresa_id}`,
          config
        )
        .then(function(response) {
          // handle success
          self.status_inv = response.data;
          self.$store.dispatch("setAllTareasPendientes", response.data);
          self.loading = false;
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.status-text {
  text-align: center;
  font-weight: bold;
  font-size: 16px !important;
}
.color-bhp-text {
  color: #07758d;
  font-weight: bold;
}
.fondo-amarillo-a {
  background-color: #727997;
  color: white;
}
.fondo-amarillo-b {
  background-color: #62636b;
  color: white;
}
.fondo-verde-a {
  background-color: #07758d;
  color: white;
}
td {
  padding: 5px;
}

.border {
  border: 1px solid black;
}

.content {
  min-height: 50vh;
}

.text-center {
  text-align: center;
}

.red-text {
  color: red;
}

.border_red {
  border: 4px solid red;
}

.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}
@keyframes resplandorAnimation {
  0%,
  100% {
    box-shadow: 0px 0px 10px #07758d;
  }
  50% {
    box-shadow: 0px 0px 0px #07758d;
  }
}

.username {
  color: #07758d;
  font-size: 24px;
}

.content-username {
  margin-left: 21px;
  text-align: center;
  max-width: 990px;
}
</style>

<style>
.el-alert__description {
  font-size: 15px !important;
  color: black !important;
}
.el-alert__title {
  font-size: 15px !important;
  color: black !important;
}
.el-alert__content {
  padding: 10px !important;
}
</style>